export default __webpack_public_path__ + "static/la-rose-the-tunis-golden-ratio-920ed4da35052e4aaf8b499601845d5c.jpg";